/* blog-cycle-notes.js — search, filter, sort, load-more */
(function () {
  'use strict';

  var PER_PAGE    = window.BCN_POSTS_PER_PAGE || 9;
  var shown       = 0;
  var activeTag   = '';
  var searchQuery = '';
  var sortMode    = 'newest';

  var grid         = document.getElementById('bcn-grid');
  var noResults    = document.getElementById('bcn-no-results');
  var loadMoreWrap = document.getElementById('bcn-load-more-wrap');
  var loadMoreBtn  = document.getElementById('bcn-load-more-btn');
  var loadCount    = document.getElementById('bcn-load-count');
  var countEl      = document.getElementById('bcn-count');
  var searchInput  = document.getElementById('bcn-search-input');
  var searchWrap   = document.getElementById('bcn-search-wrap');
  var clearBtn     = document.getElementById('bcn-search-clear');
  var sortSelect   = document.getElementById('bcn-sort-select');
  var filtersEl    = document.getElementById('bcn-filters');
  var resetBtn     = document.getElementById('bcn-reset');

  if (!grid) return;

  var allCards = Array.from(grid.querySelectorAll('.post'));

  /* ── FILTER + SORT ────────────────────────────────── */
  function getMatchingCards() {
    return allCards.filter(function (card) {
      var matchTag = true;
      var matchSearch = true;

      if (activeTag) {
        var tags = (card.dataset.tags || '').split('|');
        matchTag = tags.some(function (t) {
          return t.trim().toLowerCase() === activeTag.toLowerCase();
        });
      }

      if (searchQuery) {
        var title   = (card.dataset.title   || '').toLowerCase();
        var summary = (card.dataset.summary || '').toLowerCase();
        matchSearch = title.includes(searchQuery) || summary.includes(searchQuery);
      }

      return matchTag && matchSearch;
    });
  }

  function sortCards(cards) {
    return cards.slice().sort(function (a, b) {
      if (sortMode === 'oldest') return Number(a.dataset.date) - Number(b.dataset.date);
      if (sortMode === 'alpha')  return (a.dataset.title || '').localeCompare(b.dataset.title || '');
      return Number(b.dataset.date) - Number(a.dataset.date); // newest
    });
  }

  function render(reset) {
    if (reset) shown = 0;

    var matching = sortCards(getMatchingCards());

    // Hide all cards
    allCards.forEach(function (card) { card.hidden = true; });

    // Re-order DOM to match sort
    matching.forEach(function (card) { grid.appendChild(card); });

    // Show up to current page
    shown = reset ? PER_PAGE : shown + PER_PAGE;
    shown = Math.min(shown, matching.length);
    for (var i = 0; i < matching.length; i++) {
      matching[i].hidden = (i >= shown);
    }

    // Empty state
    if (noResults) noResults.hidden = matching.length > 0;

    // Toolbar count
    if (countEl) {
      countEl.textContent = matching.length === allCards.length
        ? matching.length + ' ARTICLES'
        : matching.length + ' OF ' + allCards.length + ' ARTICLES';
    }

    // Load-more
    var remaining = matching.length - shown;
    if (loadMoreWrap) loadMoreWrap.hidden = remaining <= 0;
    if (loadCount && remaining > 0) {
      loadCount.textContent = 'Showing ' + shown + ' of ' + matching.length;
    }
  }

  /* ── FILTER PILLS ────────────────────────────────── */
  if (filtersEl) {
    filtersEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.alori-tag');
      if (!btn) return;
      activeTag = btn.dataset.tag || '';
      filtersEl.querySelectorAll('.alori-tag').forEach(function (b) {
        var active = b === btn;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      render(true);
    });
  }

  /* ── SEARCH ──────────────────────────────────────── */
  if (searchInput) {
    var debounceTimer;
    searchInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      // Toggle has-value class for clear button visibility
      if (searchWrap) searchWrap.classList.toggle('has-value', !!searchInput.value);
      debounceTimer = setTimeout(function () {
        searchQuery = searchInput.value.trim().toLowerCase();
        render(true);
      }, 220);
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      if (searchInput) {
        searchInput.value = '';
        searchInput.dispatchEvent(new Event('input'));
        searchInput.focus();
      }
    });
  }

  /* ── SORT ────────────────────────────────────────── */
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      sortMode = sortSelect.value;
      render(true);
    });
  }

  /* ── LOAD MORE ───────────────────────────────────── */
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      var prevShown = shown;
      render(false);
      // Scroll to first newly visible card
      var matching = sortCards(getMatchingCards());
      var firstNew = matching[prevShown];
      if (firstNew) firstNew.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  /* ── RESET ───────────────────────────────────────── */
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      activeTag   = '';
      searchQuery = '';
      sortMode    = 'newest';
      if (searchInput) {
        searchInput.value = '';
        if (searchWrap) searchWrap.classList.remove('has-value');
      }
      if (sortSelect) sortSelect.value = 'newest';
      if (filtersEl) {
        filtersEl.querySelectorAll('.alori-tag').forEach(function (b) {
          var isAll = !b.dataset.tag;
          b.classList.toggle('is-active', isAll);
          b.setAttribute('aria-pressed', isAll ? 'true' : 'false');
        });
      }
      render(true);
    });
  }

  /* ── INITIAL RENDER ──────────────────────────────── */
  render(true);

})();
